"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SearchResultsIcon = function SearchResultsIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("mask", {
    id: "SearchResults_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "#2B2B2B"
  })), React.createElement("g", {
    mask: "url(#SearchResults_svg__a)",
    fill: "#2B2B2B"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.083 7.125H3.708v10.25h6.834v1.709H3.708A1.71 1.71 0 012 17.375V3.708A1.71 1.71 0 013.708 2h15.376a1.71 1.71 0 011.708 1.708v5.98h-1.71V7.125zM7.979 3.708v1.709h2.563V3.708H7.979zm4.271 1.709h6.834V3.708H12.25v1.709zm-5.979 0V3.708H3.708v1.709h2.563z"
  }), React.createElement("path", {
    d: "M4.563 10.542V8.834h3.416v1.708H4.563zm5.125-1.708h3.416v1.708H9.688V8.834zm-2.563 2.562H4.563v1.708h2.562v-1.708zm-2.562 4.271v-1.708h3.416v1.708H4.563z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20.792l-2.774-2.773a4.244 4.244 0 00.712-2.352 4.276 4.276 0 00-4.271-4.27 4.276 4.276 0 00-4.27 4.27 4.276 4.276 0 004.27 4.271c.837 0 1.655-.248 2.352-.712L20.792 22 22 20.792zm-8.896-5.125a2.566 2.566 0 012.563-2.563 2.566 2.566 0 012.563 2.563 2.566 2.566 0 01-2.563 2.563 2.566 2.566 0 01-2.563-2.563z"
  }), React.createElement("path", {
    d: "M18.23 8.834h-3.417v.854h3.417v-.854zm-9.396 2.562h1.708v1.708H8.834v-1.708zm1.708 2.563h-.854v1.708h.854v-1.708z"
  })));
};

var _default = SearchResultsIcon;
exports.default = _default;